;(function (Wishlist, $) {

  var $wishlistButton = $('.wishlist-btn');
  var $wishlistTile = $('.wishlist-tile-container');
  var $wishlitcounter = $('.wishlist-counter');
  var numProductTiles = $wishlistTile.length;

  var wishlist = [];
  try {
    wishlist = JSON.parse(localStorage.getItem('user_wishlist')) || [];
  } catch (e) {
    wishlist = [];
  }

  // Count is always derived from the actual wishlist array length —
  // no separate counter key, so it can never go out of sync.
  var updateCounterDisplay = function () {
    $wishlitcounter.html(wishlist.length);
  };
  updateCounterDisplay();

  /*
   * Update button to show current state (gold for active)
   */
  var animateWishlist = function (self) {
    $(self).toggleClass('is-active');
  };

  /*
   * Add/Remove selected item to the user's wishlist array in localStorage
   * Wishlist button class 'is-active' determines whether or not to add or remove
   * If 'is-active', remove the item, otherwise add it
   * NOTE: icon markup is never swapped anymore — the heart icon stays the
   * same, only the 'is-active' class toggles so CSS can change its color/fill.
   */
  var updateWishlist = function (self) {
    var productHandle = $(self).attr('data-product-handle');
    var isRemove = $(self).hasClass('is-active');

    /* Remove */
    if (isRemove) {
      var removeIndex = wishlist.indexOf(productHandle);
      if (removeIndex > -1) {
        wishlist.splice(removeIndex, 1);
      }
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
      updateCounterDisplay();
    }
    /* Add */
    else {
      if (wishlist.indexOf(productHandle) === -1) {
        wishlist.push(productHandle);
      }
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
      updateCounterDisplay();
    }
  };

  /*
   * Loop through wishlist buttons and activate any items that are already in user's wishlist
   * Activate by adding class 'is-active'
   * Run on initialization
   */
  var activateItemsInWishlist = function () {
  $wishlistButton.each(function () {
    var productHandle = $(this).attr('data-product-handle');
    if (wishlist.indexOf(productHandle) > -1) {
      $(this).addClass('is-active');
    }
  });
};

  /*
   * Loop through product titles and remove any that aren't a part of the wishlist
   * Decrement numProductTiles on removal
   */
  var displayOnlyWishlistItems = function () {
    $wishlistTile.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) === -1) {
        $(this).remove();
        numProductTiles--;
      }
    });
  };

  /*
   * Check if on the wishlist page and hide any items that aren't a part of the wishlist
   * If no wishlist items exist, show the empty wishlist notice
   */
  var loadWishlist = function () {
    if (window.location.href.indexOf('pages/wishlist') > -1) {
      displayOnlyWishlistItems();
      $('.wishlist-loader').fadeOut(2000, function () {
        $('.wishlist-grid').addClass('is_visible');
        $('.wishlist-hero').addClass('is_visible');
        if (numProductTiles == 0) {
          $('.wishlist-grid-empty-list').addClass('is_visible');
          $('.wishlist-grid').hide();
        } else {
          $('.wishlist-grid-empty-list').hide();
        }
      });
    }
  };

  var bindUIActions = function () {
    // IMPORTANT: only the clicked button (`this`) is updated —
    // not the whole $wishlistButton collection — otherwise every
    // heart icon on the page flips to a cross at once.
    $wishlistButton.click(function (e) {
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
    });
  };

  Wishlist.init = function () {
    bindUIActions();
    activateItemsInWishlist();
    loadWishlist();
  };

  // Remove All Items..
  $('#remove-done').click(function () {
    wishlist = [];
    localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
    localStorage.removeItem('user_wishlist_count'); // drop legacy key if present
    location.reload(true);
  });

}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));

function reloadPage() {
  location.reload(true);
}
